import { HTMLAttributes } from 'react';

export function Hr(props: HTMLAttributes<HTMLHRElement>) {
  const { className = '' } = props;
  return <hr className={`${className} border-t border-border my-4 w-full`} />;
}
